/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const CLAN_INFO_PANEL_CREATED_AT = date => (
    <FormattedMessage
        id='clan_info_panel.created_at'
        defaultMessage='Создан {date}'
        values={{ date }}
    />
)



// WEBPACK FOOTER //
// ./containers/Stronghold/components/ClanInfoPanel/constants.jsx